<template>
  <div class="container">
    <div class="goBackBtn" @click="$router.go(-1)">
      <h2>
        X
      </h2>
    </div>
    <div id="cookies-policy" class="cookies-policy" v-html="cookies"></div>
    <!-- OneTrust Cookies List start -->
    <div id="ot-sdk-cookie-policy" data-document-language="true"> </div>
    <!-- OneTrust Cookies List end -->
  </div>
</template>

<script>
import Axios from 'axios';
import { mapActions } from "vuex";
export default {
  name: "Cookies",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx",
    },
  },
  data(){
    return {
      cookies:'',  
    }
  },
  async mounted(){
    window.scrollTo(0,0)
    //let serviceResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/cookies/aviso/V1')
    let serviceResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/cookies/aviso/V2')
    this.cookies = serviceResponse.data.replace('{', '').replace('"body":"', '').replace(`";
        }`,'')
    
    if (this.$route.path === '/cookies') {
      this.$nextTick(() => {
        setTimeout(() => {
          if (typeof Optanon !== 'undefined' && typeof Optanon.initializeCookiePolicyHtml === 'function') {
            Optanon.initializeCookiePolicyHtml();
          }
        }, 100);
      });
    }
  },
  async beforeRouteLeave() {
    this.setAgeGateTokenAction(false)
    location.reload()
  },
  watch: {
    '$route.path'(newPath) {
      if (newPath === '/cookies') {
        this.$nextTick(() => {
          setTimeout(() => {
            if (typeof Optanon !== 'undefined' && typeof Optanon.initializeCookiePolicyHtml === 'function') {
              Optanon.initializeCookiePolicyHtml();
            } else {
              console.warn('OneTrust not yet loaded or method missing');
            }
          }, 100);
        });
      }
    }
  },
  methods: {
    ...mapActions({
      setAgeGateTokenAction: "setAgeGateToken",
    }),
  }
};
</script>
<style lang="scss" >
@import "~@/styles/variables.scss";

.goBackBtn {
  display: flex;
  flex-direction: row;
  //width: 130px;
  width: 80px;
  background-color: transparent;
  border: none;
  color: $black;
  font-family: $font-Dunbar-Light;
  //margin-left: 2rem;
  font-size: 1.4vw;
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  h2 {
    color: $black !important;
    margin-inline: 0;
  }
  @media screen and (max-width: 768px) {
    //width: 80px;
    width: 42px;
    h2 {
      font-size: 4.8vw;
    }
  }
}
.goBackBtn:hover {
  cursor: pointer;
}
.cookies-policy {
  font-family: 'DunbarTall-Light' !important;
  font-size: 1.4vw !important;
  margin-right: 24.2pt !important;
  margin-left: 16.2pt !important;
  text-align: justify;
  color: $black !important;
  padding-inline: 2vw;
  padding-bottom: 5vw;
  margin-top: 7vw !important;
  text-transform: uppercase !important;
  p {
    margin-bottom: 2vw;
  }
  span {
    font-size: 1.2vw !important;
  }
  @media (max-width: 768px) {
    font-size: 5.3vw !important;
    margin-right: 18.2pt !important;
    margin-left: 10.2pt !important;
    //margin-top: 20vw !important;
    span {
      font-size: 4vw !important;
    }
  }
  table {
    width: 100% !important;
    border-collapse: collapse !important;
    @media (max-width: 768px) {
      width: 0% !important;
    }
  }
  tr {
    font-size: 1.1vw !important;
    @media (max-width: 768px) {
      font-size: 2.3vw !important;
    }
  }
  th {
    border: solid 1px;
    @media (max-width: 768px) {
      font-size: 2.3vw !important;
    }
  }
  td {
    border: solid 1px;
    @media (max-width: 768px) {
      font-size: 2.3vw !important;
    }
  }
}
</style>